import { Custom } from "components";
import { Stack } from "@mui/material";
import { useApp, useTheme } from "contexts";
import { IFeedback } from "interfaces";

export type Props = {
  t: any;
  values: IFeedback;
  workflow?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Fields = ({ t, workflow = false, values, onChange }: Props) => {
  const { theme } = useTheme();

  return (
    <>
      {workflow && (
        <>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.label.name}
          </Custom.Typography>
          <Custom.TextField
            type="text"
            name="name"
            required
            onChange={onChange}
            placeholder={t.placeholder.name}
            value={values.name}
          />{" "}
        </>
      )}
      {workflow && (
        <>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.label.email}
          </Custom.Typography>
          <Custom.TextField
            type="email"
            name="email"
            required
            onChange={onChange}
            placeholder={t.placeholder.email}
            value={values.email}
          />
        </>
      )}
      <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
        {t.label.feedback.rating}
      </Custom.Typography>
      <Custom.Rating
        name="rating"
        value={values.rating}
        onChange={(name: string, value: number) =>
          onChange({
            target: {
              name,
              value,
            },
          } as any)
        }
      />
      <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
        {t.label.feedback.message}
      </Custom.Typography>
      <Custom.TextField
        type="text"
        name="comment"
        required
        multiline
        onChange={onChange}
        placeholder={t.placeholder.add_comments}
        value={values.comment}
      />
      {workflow && (
        <>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.label.feedback.follow_up}
          </Custom.Typography>
          <Custom.Checkbox name="follow_up" label={t.checkbox.follow_up} />
        </>
      )}
    </>
  );
};
